module.exports = __webpack_public_path__ + "img/img-top-xs.d848a4e1.jpg";